import React from 'react'

function Undefined() {
    return (
        <span className='cs-data-undefined'>Undefined</span>
    )
}

export { Undefined }